import { ff } from '@atlassian/jira-feature-flagging';
import { createRelayResource } from '@atlassian/jira-relay-utils';
import QUERY, {
	type tabs_jwmNavigationItemsQuery as JiraNavigationItemsQuery,
} from '@atlassian/jira-relay/src/__generated__/tabs_jwmNavigationItemsQuery.graphql';
import { resourceWithCondition2, getProjectKeyId } from '@atlassian/jira-router-resources-utils';

const RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_NAVIGATION_ITEMS';

export const navigationItemsResource = createRelayResource<JiraNavigationItemsQuery>({
	type: RESOURCE_TYPE_KEY,
	getQuery: ({ match, query }, { tenantContext }) => {
		const { projectKey, projectId } = getProjectKeyId(match, query);
		const { cloudId } = tenantContext;
		const projectIdOrKey = projectKey || projectId;

		return {
			parameters: QUERY,
			variables: {
				cloudId,
				projectIdOrKey,
				first: 50,
			},
			options: { fetchPolicy: 'store-and-network' },
		};
	},
});

export const navigationItemsWithConditionResource = resourceWithCondition2(
	() => ff('jwm.custom-project-navigation'),
	navigationItemsResource,
);
